// Copyright (c) 2020 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as ToolbarSlice from "../slice"
import { TOOLBAR_FILTERS_KEY } from "./index"
import { ofType } from "redux-observable"
import { PersistedToolbar } from "generated/timeline/toolbar/toolbar_pb"

export type StorageReader = () => Observable<string>

const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(TOOLBAR_FILTERS_KEY)
    if (data !== null) {
      return of(data)
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const deserialize = (value: string): PersistedToolbar.AsObject => {
  // The toolbar is saved as a JSON array of the protobuf serialization buffer.
  // This is needed as it's not trivial to serialize a Uint8Array to base64 while supporting IE 11.
  const array = JSON.parse(value)
  const buffer = new Uint8Array(array)
  return PersistedToolbar.deserializeBinary(buffer).toObject()
}

export const loadToolbarFilters = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      ofType(Actions.loadToolbarFiltersFromStorage),
      mergeMap(_ => load().pipe(
        map(deserialize),
        map(ToolbarSlice.setPersistedToolbar),
        catchError(_ => of(Actions.toolbarFiltersLoadFailed())),
      )),
    )

export default loadToolbarFilters(load)

